<template>
  <div
    class="admin-toast-container pointer-events-none fixed bottom-4 left-4 right-4 z-[140] mx-auto flex max-w-sm flex-col-reverse gap-2 sm:bottom-auto sm:left-auto sm:right-6 sm:top-24 sm:flex-col sm:mx-0"
    aria-live="polite"
    aria-atomic="false"
  >
    <TransitionGroup name="admin-toast">
      <div
        v-for="toast in adminToasts"
        :key="toast.id"
        class="admin-toast pointer-events-auto overflow-hidden rounded-xl border shadow-lg"
        :class="toastClass(toast.type)"
        role="status"
      >
        <div class="flex items-start gap-3 px-4 py-3">
          <span
            class="material-symbols-outlined mt-0.5 shrink-0 text-[20px]"
            aria-hidden="true"
          >
            {{ toastIcon(toast.type) }}
          </span>
          <p class="flex-1 text-sm font-medium leading-snug">{{ toast.message }}</p>
          <button
            type="button"
            class="shrink-0 rounded-md p-0.5 opacity-70 transition-opacity hover:opacity-100"
            aria-label="Dismiss notification"
            @click="dismissAdminToast(toast.id)"
          >
            <span class="material-symbols-outlined text-[18px]">close</span>
          </button>
        </div>
        <div
          v-if="toast.duration > 0"
          class="h-1 w-full"
          :class="progressTrackClass(toast.type)"
        >
          <div
            class="toast-progress h-full"
            :class="progressBarClass(toast.type)"
            :style="{ animationDuration: `${toast.duration}ms` }"
          />
        </div>
      </div>
    </TransitionGroup>
  </div>
</template>

<script setup>
import {
  adminToasts,
  dismissAdminToast,
} from "../../utils/adminToast.js";

const toastClass = (type) =>
  type === "error"
    ? "border-error/30 bg-error-container text-error"
    : "border-primary/30 bg-surface text-on-surface shadow-[0_10px_30px_rgba(21,66,18,0.12)]";

const toastIcon = (type) => (type === "error" ? "error" : "check_circle");

const progressTrackClass = (type) =>
  type === "error" ? "bg-error/10" : "bg-primary/10";

const progressBarClass = (type) =>
  type === "error" ? "bg-error" : "bg-primary";
</script>

<style scoped>
.admin-toast-enter-active,
.admin-toast-leave-active {
  transition: all 0.25s ease;
}

.admin-toast-enter-from,
.admin-toast-leave-to {
  opacity: 0;
  transform: translateY(1rem);
}

@media (min-width: 640px) {
  .admin-toast-enter-from,
  .admin-toast-leave-to {
    transform: translateX(1rem);
  }
}

.admin-toast-move {
  transition: transform 0.25s ease;
}

.toast-progress {
  width: 100%;
  transform-origin: left center;
  animation: toast-progress-shrink linear forwards;
}

@keyframes toast-progress-shrink {
  from {
    transform: scaleX(1);
  }

  to {
    transform: scaleX(0);
  }
}
</style>
